import { allBrands, datatypes, inputTypes, arrType, selectOptionsKeyName } from "data/globalData";
import { channelTypes } from "../BuyingSheet/data";

export const storeProjectionColumns = [
	{
		name: "Channel",
		key: "channel",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		default_value: "",
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object.keys(channelTypes)?.map((row) => {
				return channelTypes[row];
			}),
		},
	},
	{
		name: "Season",
		key: "season",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
	{
		name: "Stores Count",
		key: "stores_count",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
	{
		name: "Growth AVG",
		key: "avg_growth",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
];

export const projectionDummyData = [
	{
		channel: "EBO",
		season: "2023-24",
		stores_count: 100,
		avg_growth: 10,
		id: 1,
	},
	{
		channel: "MBO",
		season: "2023-24",
		stores_count: 100,
		avg_growth: 10,
		id: 2,
	},

	{
		channel: "LFS",
		season: "2023-24",
		stores_count: 100,
		avg_growth: 10,
		id: 3,
	},
];

export const storesTableColumns = [
	{
		name: "Store Code",
		key: "store_code",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		default_value: "",
	},
	{
		name: "Store Name",
		key: "store_name",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
	{
		name: "Short Name",
		key: "store_short_name",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
	{
		name: "Age",
		key: "age",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
];
export const storeTableDummyData = [
	{
		store_code: "RR001",
		store_name: "UB CITY BLR",
		store_short_name: "RR-UB-CITY",
		age: 10,
		id: 1,
	},
];
